/* import __COLOCATED_TEMPLATE__ from './icon-mute.hbs'; */
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--mute'],
  width: 32,
  height: 32,
  viewBox: '0 0 32 32'
});